export default __webpack_public_path__ + "static/img_interviewee_hcho@2x-89e26fe3598cb726fcafffdd233b5469.png";